
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {
  Code,
  ComponentDocs,
  Preview,
} from "@lighting-beetle/lighter-styleguide";
import { Checkbox, Radio, RadioCheckGroup } from "../";
import { Grid, GridCol } from "./../../";
import RadioCheck from "./";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Checkbox / Radio`}</h1>
    <h2>{`Example`}</h2>
    <Checkbox key="checkbox" id="checkbox-example" label="Checkbox" mdxType="Checkbox" />
    <Radio key="radio" id="radio-example" label="Radio" mdxType="Radio" />
    <h2>{`Variants`}</h2>
    <h3>{`Basic`}</h3>
    <Preview mdxType="Preview">
  <Grid mdxType="Grid">
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <Checkbox id="checkbox" label="Checkbox" mdxType="Checkbox" />
    </GridCol>
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <Radio id="radio" label="Radio" mdxType="Radio" />
    </GridCol>
  </Grid>
    </Preview>
    <h3>{`States`}</h3>
    <Preview code={[<Checkbox id="checkbox-states-focus" label="Active" isActive isChecked mdxType="Checkbox" />, <Checkbox id="checkbox-states-disabled" label="Disabled" isDisabled isChecked mdxType="Checkbox" />, <Checkbox id="checkbox-states-error" label="Error" error isChecked mdxType="Checkbox" />, <Radio name="radio-states" id="radio-states-focus" label="Active" isActive mdxType="Radio" />, <Radio name="radio-states" id="radio-states-disabled" label="Disabled" isDisabled mdxType="Radio" />, <Radio name="radio-states" id="radio-states-error" label="Error" error mdxType="Radio" />]} mdxType="Preview">
  <Grid mdxType="Grid">
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <Checkbox id="checkbox-states-active" label="Active" isActive mdxType="Checkbox" />
      <Checkbox id="checkbox-states-disabled" label="Disabled" isDisabled mdxType="Checkbox" />
      <Checkbox id="checkbox-states-error" label="Error" error mdxType="Checkbox" />
    </GridCol>
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <Radio name="radio-states" id="radio-states-focus" label="Active" isActive mdxType="Radio" />
      <Radio name="radio-states" id="radio-states-disabled" label="Disabled" isDisabled mdxType="Radio" />
      <Radio name="radio-states" id="radio-states-error" label="Error" error mdxType="Radio" />
    </GridCol>
  </Grid>
    </Preview>
    <h3>{`Groups`}</h3>
    <Preview code={[<RadioCheckGroup mdxType="RadioCheckGroup">
      <Checkbox name="checkbox-group" id="checkbox-group-1" label="Checkbox 1" mdxType="Checkbox" />
      <Checkbox name="checkbox-group" id="checkbox-group-2" label="Checkbox 2" mdxType="Checkbox" />
      <Checkbox name="checkbox-group" id="checkbox-group-3" label="Checkbox 3" mdxType="Checkbox" />
    </RadioCheckGroup>, <RadioCheckGroup mdxType="RadioCheckGroup">
      <Radio name="radio-group" id="radio-group-1" label="Radio 1" mdxType="Radio" />
      <Radio name="radio-group" id="radio-group-2" label="Radio 2" mdxType="Radio" />
      <Radio name="radio-group" id="radio-group-3" label="Radio 3" mdxType="Radio" />
    </RadioCheckGroup>]} mdxType="Preview">
  <Grid mdxType="Grid">
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <RadioCheckGroup mdxType="RadioCheckGroup">
        <Checkbox name="checkbox-group" id="checkbox-group-1" label="Checkbox 1" mdxType="Checkbox" />
        <Checkbox name="checkbox-group" id="checkbox-group-2" label="Checkbox 2" mdxType="Checkbox" />
        <Checkbox name="checkbox-group" id="checkbox-group-3" label="Checkbox 3" mdxType="Checkbox" />
      </RadioCheckGroup>
    </GridCol>
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <RadioCheckGroup mdxType="RadioCheckGroup">
        <Radio name="radio-group" id="radio-group-1" value="radio-group-1" label="Radio 1" mdxType="Radio" />
        <Radio name="radio-group" id="radio-group-2" value="radio-group-2" label="Radio 2" mdxType="Radio" />
        <Radio name="radio-group" id="radio-group-3" value="radio-group-3" label="Radio 3" mdxType="Radio" />
      </RadioCheckGroup>
    </GridCol>
  </Grid>
    </Preview>
    <h3>{`Group labels`}</h3>
    <Preview mdxType="Preview">
  <Grid mdxType="Grid">
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <RadioCheckGroup legend="Group legend" help="Group help" mdxType="RadioCheckGroup">
        <Checkbox name="checkbox-group-labels" id="checkbox-group-label-1" label="Checkbox 1" mdxType="Checkbox" />
        <Checkbox name="checkbox-group-labels" id="checkbox-group-label-2" label="Checkbox 2" mdxType="Checkbox" />
        <Checkbox name="checkbox-group-labels" id="checkbox-group-label-3" label="Checkbox 3" mdxType="Checkbox" />
      </RadioCheckGroup>
    </GridCol>
    <GridCol size={{
          s: 6,
          l: 3
        }} mdxType="GridCol">
      <RadioCheckGroup legend="Group legend" error="Group error" help="Group help" mdxType="RadioCheckGroup">
        <Checkbox name="checkbox-group-label-error" id="checkbox-group-label-error-1" error label="Checkbox 1" mdxType="Checkbox" />
        <Checkbox name="checkbox-group-label-error" id="checkbox-group-label-error-2" error label="Checkbox 2" mdxType="Checkbox" />
        <Checkbox name="checkbox-group-label-error" id="checkbox-group-label-error-3" error label="Checkbox 3" mdxType="Checkbox" />
      </RadioCheckGroup>
    </GridCol>
  </Grid>
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<Checkbox /> and <Radio />" component={RadioCheck} excludes={["type"]} mdxType="ComponentDocs" />
    <ComponentDocs title="<RadioCheckGroup />" component={RadioCheckGroup} mdxType="ComponentDocs" />
    <h2>{`Accessiblity`}</h2>
    <p>{`Always provide a meaningful label for each radio/checkbox.`}</p>
    <Code inline={false} language="jsx" mdxType="Code">
  {`<Checkbox /> === <RadioCheck type="checkbox" />
<Radio /> === <RadioCheck type="radio" />`}
    </Code>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;